import React from "react";
import { DesktopMenuItem } from "./HeaderMenu.styled";
import type { PageInfo } from "../../../constants/pages";
import Rectangle from "../../Rectangle/Rectangle";

type HeaderMenuItemProps = PageInfo & {
  pathname: string;
  onClick?: () => void;
};

const HeaderMenuItem: React.FC<HeaderMenuItemProps> = (page) => {
  return (
    <DesktopMenuItem to={page.route ?? page.pathname} onClick={page.onClick}>
      <span>{page.title}</span>
      {page.pathname === page.route && <Rectangle width={"100%"} height={4} />}
    </DesktopMenuItem>
  );
};

export default HeaderMenuItem;

/**/
